import { z } from "@/zod";
import {
  readQuestionnaire,
  writeQuestionnaire,
  questionnaireComment,
  regulationsSchema,
} from "@/schemas/questionnaire";
import {
  AttachmentFormValue,
  QuestionnaireAttachmentMeta,
} from "@/modules/agreement/questionnaires/types/attachments";

export type ReadQuestionnaire = z.infer<typeof readQuestionnaire>;
export type WriteQuestionnaire = z.infer<typeof writeQuestionnaire>;
export type QuestionnaireComment = z.infer<typeof questionnaireComment>;
export type RegulationsData = z.infer<typeof regulationsSchema>;

export type QuestionnaireAttachmentWithMeta = QuestionnaireAttachmentMeta;

export interface ValidationError {
  message: string;
  errors: Record<string, string>;
}

export interface EmploymentCertificateWarningInput {
  isEmployed: boolean | null | undefined;
  issueDate: string | null | undefined;
  existingAttachments?: QuestionnaireAttachmentMeta[] | null;
  newAttachments?: AttachmentFormValue[] | null;
}

export const ZUS_INSTRUCTIONAL_VIDEOS_MIN_AGE = 18;
export const ZUS_INSTRUCTIONAL_VIDEOS_MAX_AGE = 55;
export const ZUS_INSTRUCTIONAL_VIDEOS_STUDENT_MAX_AGE = 26;

export const DISABILITY_PENSION_TYPE = {
  FAMILY: "family",
  SOCIAL: "social",
  DISABILITY: "disability",
  OTHER: "other",
} as const;

export const DISABILITY_PENSION_TYPE_VALUES = Object.values(
  DISABILITY_PENSION_TYPE,
) as [string, ...string[]];

export interface ConditionalFieldConfig {
  checkbox: keyof WriteQuestionnaire;
  dependentFields: (keyof WriteQuestionnaire)[];
  requiredFields: (keyof WriteQuestionnaire)[];
  attachmentFields?: (keyof WriteQuestionnaire)[];
}
